<template>
  <v-bottom-sheet v-model="sheetNote" persistent>
    <template v-slot:activator="{ on, attrs }">
      <div class="footer">
        <div class="footer-card" v-bind="attrs" v-on="on">+ เพิ่ม NOTE VOC</div>
      </div>
    </template>

    <v-sheet
      class="text-center"
      height="1500px"
      style="max-height: 1500px; overflow: scroll"
    >
      <ChipsTags
        v-if="dialogTag"
        @closeTag="closeTags"
        @selectTag="selectTags"
        @selectTagsFirst="selectStockShare"
        :dataTag="tags"
        :statusTags="sheetStockShare"
      />

      <!-- tool bar -->
      <v-toolbar v-else class="toobar-v">
        <v-toolbar-title
          class="grey--text text-close"
          @click="sheetNote = !sheetNote"
        >
          ปิด
        </v-toolbar-title>

        <v-btn icon class="icon-btn" @click="$refs.file_image.click()">
          <i class="icon-Like-Copy font-42"></i>
          <input
            type="file"
            ref="file_image"
            hidden
            accept="image/*"
            multiple
            @change="uploadImage"
          />
        </v-btn>

        <v-spacer class="px-2" style="margin: 0px 4px">
          <div class="switch-group">
            <input
              v-model="form.type"
              type="radio"
              class="switch-radio"
              name="option_"
              id="optionL"
              value="0"
              checked
            />
            <label class="switch-radio-label" for="optionL">NOTE</label>

            <input
              v-model="form.type"
              type="radio"
              class="switch-radio"
              name="option_"
              id="optionR"
              value="1"
            />
            <label class="switch-radio-label" for="optionR">VOC</label>
          </div>
        </v-spacer>

        <div class="d-flex align-center">
          <v-btn icon class="icon-btn" @click="dialogTag = true">
            <img src="img/icons_v2/ico-price-tag@3x.png" class="icon-size" />
          </v-btn>

          <v-btn icon class="icon-btn" @click="dialogPerson = true">
            <img src="img/icons_v2/icon-add-user@3x.png" class="icon-size" />
            <div v-if="dataPerson.length > 0">
              <div class="icon-notiuser">
                <span>{{ dataPerson.length }}</span>
              </div>
            </div>
          </v-btn>

          <v-btn icon class="icon-btn">
            <img src="img/icons_v2/ico-attach@3x.png" class="icon-size" />
          </v-btn>
        </div>
      </v-toolbar>

      <div v-if="!sheetStockShare">
        <div class="content-tag">
          <AttributePerson
            v-if="dataPerson != ''"
            :item="dataPerson"
            @remove="removePerson"
          />
        </div>

        <div class="content-tag">
          <AttributeTags v-if="dataTag != ''" :item="dataTag" />
        </div>

        <DialogPerson
          :dialog="dialogPerson"
          :select="dataPerson"
          @close="closeDialogPerson"
          @save="saveDialogPerson"
        />

        <div class="content-message container">
          <v-col v-if="dataStockShare != ''">
            <v-text-field
              color="#a50200"
              height="70"
              outlined
              append-icon="icon-Search"
              placeholder="ค้นหา"
              @focus="selectStockShare(true)"
            />
          </v-col>
          <textarea
            ref="massage"
            v-model="form.detail"
            cols="60"
            rows="10"
            placeholder="ระบุข้อความ"
            autofocus
            style="width: 100%; border: none !important"
          />
        </div>

        <div class="content-chipsiamge">
          <AttributeImage
            v-if="dataFile != ''"
            :item="dataFile"
            @remove="removeImage"
          />
        </div>

        <v-toolbar class="toobar-v footer-submit">
          <!-- <div style="width: 00px !important;">&nbsp;</div> -->

          <v-spacer style="margin-top: 10%">
            <div class="" @click="recordVoice()">
              <button id="speech" class="btn" :class="{ active: statusRecode }">
                <img
                  src="img/icons_v2/icon-microphone.png"
                  class="icon-microphone"
                />
                <div v-if="statusRecode" class="pulse-ring"></div>
              </button>
            </div>
          </v-spacer>

          <div class="scard-sm">
            <v-btn
              class="btn-submit"
              :disabled="form.detail === ''"
              @click="saveForm()"
            >
              บันทึก
            </v-btn>
          </div>
        </v-toolbar>
      </div>

      <div v-else>
        <StockShare :customerId="id_customer" @save="resStockShare" />
      </div>

      <template>
        <DialogConfirmCustomer
          :dialog="dialogConfirm"
          :customerId="id_customer"
          :customerItem="listCustomer"
          @save="saveDialogConfirm"
          @close="dialogConfirm = false"
        />
      </template>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import ChipsTags from '@/components/v2/ChipsTags.vue'
import DialogPerson from '@/components/v2/DialogPerson.vue'
import DialogConfirmCustomer from '@/components/v2/DialogConfirmCustomer.vue'
import AttributePerson from '@/components/v2/notevoc/AttributePerson.vue'
import AttributeTags from '@/components/v2/notevoc/AttributeTags.vue'
import AttributeImage from '@/components/v2/notevoc/AttributeImage.vue'
import StockShare from '@/components/v2/notevoc/StockShare.vue'
import { mapState } from 'vuex'
export default {
  props: ['tags', 'customerID', 'customer', 'mode', 'listCustomer'],
  components: {
    ChipsTags,
    DialogPerson,
    DialogConfirmCustomer,
    AttributePerson,
    AttributeTags,
    AttributeImage,
    StockShare,
  },

  data() {
    return {
      dialogTag: false,
      dialogPerson: false,
      dialogConfirm: false,
      sheetNote: false, // setting > open dialog add note/voc
      sheetStockShare: false,
      statusRecode: false,
      dataTag: [],
      dataPerson: [],
      dataStockShare: [],
      dataFile: [],
      form: {
        note_id: ``,
        user_id: ``,
        customer_id: ``,
        detail: ``,
        note_write: ``,
        type: 0,
        tag: [],
        team: [],
        file: [],
        items: [],
      },
      id_customer: ``,
      actionEdit: false,
      stateCustomerId: null,
    }
  },

  watch: {
    customerID(nValue) {
      if (nValue != null || nValue != '') {
        this.id_customer = nValue
      }
    },

    mode(nValue) {
      if (nValue.mode == 'edit') {
        this.sheetNote = true
        this.modeEdit(nValue.item)
      }
    },

    sheetNote(nValue) {
      if (!nValue) return this.resetForm()
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    recognizes() {
      const SpeechRecognize =
        window.SpeechRecognition || window.webkitSpeechRecognition
      const recognize = new SpeechRecognize()
      return recognize
    },
  },

  methods: {
    closeTags() {
      this.dialogTag = false
    },

    closeDialogPerson() {
      this.dialogPerson = false
    },

    saveDialogPerson(item) {
      this.dialogPerson = false
      this.dataPerson = item
    },

    removePerson(index) {
      this.dataPerson.splice(index, 1)
    },

    selectTags(item) {
      this.dataTag = item
    },

    selectStockShare(status) {
      this.sheetStockShare = status
    },

    recordVoice() {
      this.statusRecode = !this.statusRecode
      if (this.statusRecode) {
        this.recognizes.start()
      } else {
        this.recognizes.stop()
      }
    },

    setVoicetoText(e) {
      this.form.detail += e.results[0][0].transcript
    },

    continueRecord() {
      if (this.statusRecode) {
        this.recognizes.start()
      }
    },

    setUpVoice() {
      this.recognizes.lang = 'th-TH'
      this.recognizes.addEventListener('result', this.setVoicetoText)
      this.recognizes.addEventListener('end', this.continueRecord)
    },

    uploadImage(event) {
      var files = event.target.files
      let vm = this
      for (var i = 0; i < files.length; i++) {
        this.resizeImages(files[i], function (data) {
          vm.dataFile.push({
            id: 0,
            pic: data,
          })
        })
      }
    },

    removeImage(index) {
      this.dataFile.splice(index, 1)
    },

    resStockShare(item) {
      this.sheetStockShare = false
      this.dataStockShare = item
      var str = ''
      var number = 0
      for (const i in item) {
        number++
        str += `${number}. ${item[i].name} ราคาซื้อเข้า ${item[i].wholesale_price} บาท ราคาขายออก ${item[i].retail_price} บาท ${item[i].stock} ${item[i].unit} \n`
      }
      this.form.detail = str
    },

    setForm() {
      var team = []
      var tag = []
      var file = []
      var items = []

      this.dataPerson.map((item) => {
        team.push(item.id)
      })

      this.dataTag.map((item) => {
        tag.push(item.id)
      })

      this.dataFile.map((item) => {
        file.push(item.pic)
      })

      this.dataStockShare.map((item) => {
        items.push({
          product_id: item.product_id,
          retail_price: item.retail_price,
          wholesale_price: item.wholesale_price,
          stock: item.stock,
        })
      })

      // new condition customer id.
      if (this.customerID == null || this.customerID == 'ทั้งหมด') {
        if (this.stateCustomerId != null) {
          this.form.customer_id = this.stateCustomerId
          this.id_customer = this.stateCustomerId
        } else {
          this.form.customer_id = this.id_customer
          this.id_customer = this.id_customer
        }
      } else {
        this.form.customer_id = this.customerID
        this.id_customer = this.customerID
      }

      this.form.team = team
      this.form.tag = tag
      this.form.file = file
      this.form.items = items
      this.form.user_id = this.user.id
    },

    saveForm() {
      this.setForm()

      if (
        this.id_customer == 'ทั้งหมด' ||
        this.id_customer == null ||
        this.id_customer == ''
      ) {
        this.dialogConfirm = true
      } else {
        if (this.actionEdit) {
          this.dialogConfirm = true
        } else {
          this.dialogConfirm = false
          const options = {
            url: `${this.$baseAPINew}/web/?act=save_note`,
            method: 'POST',
            data: this.form,
          }
          this.$axios(options).then((res) => {
            if (res.data === 'success') {
              Swal.fire({
                icon: 'success',
                text: 'เพิ่ม Note สำเร็จ',
                showConfirmButton: false,
                timer: 1500,
              })
              this.$emit('save')
              this.resetForm()
            } else {
              Swal.fire({
                icon: 'error',
                text: 'เพิ่ม Note ไม่สำเร็จ',
                showConfirmButton: true,
                confirmButtonText: `ตกลง`,
                confirmButtonColor: '#A9182A',
              })
            }
          })
        }
      }
    },

    saveDialogConfirm(id) {
      this.stateCustomerId = id
      this.dialogConfirm = false
      this.actionEdit = false
      this.saveForm()
    },

    modeEdit(item) {
      this.form = {
        note_id: item.note_id,
        user_id: item.user_id,
        customer_id: item.customer_id,
        detail: item.detail,
        type: item.type,
      }

      this.dataTag = this.setEditTags(item.tag)
      this.dataPerson = this.setEditPerson(item.team)
      this.dataFile = this.setEditPicture(item.files_web)
      this.id_customer = item.customer_id
      this.actionEdit = true
    },

    setEditPerson(object) {
      var result = []
      const data = object
      if (data.length != 0) {
        data.map(function (item) {
          result.push({
            id: item.user_id,
            name: item.user_name,
            customer_pic: item.customer_pic,
          })
        })
      }

      return result
    },

    setEditTags(object) {
      var result = []
      const data = object
      if (data.length != 0) {
        data.map(function (item) {
          result.push({
            id: item.note_voc_tag_id,
            name: item.name,
            color: item.color,
            type: '',
          })
        })
      }

      return result
    },

    setEditPicture(object) {
      var result = []
      const data = object
      if (data.length != 0) {
        data.map(function (item) {
          result.push({
            id: item.file_id,
            pic: item.file_name,
          })
        })
      }

      return result
    },

    resetForm() {
      this.sheetNote = false
      this.dataTag = []
      this.dataPerson = []
      this.dataStockShare = []
      this.dataFile = []
      this.form = {
        user_id: ``,
        customer_id: ``,
        detail: ``,
        note_write: ``,
        type: 0,
        tag: [],
        team: [],
        file: [],
      }

      this.id_customer = ``
      this.dialogPerson = false
      this.dialogTag = false
      this.sheetStockShare = false
      this.statusRecode = false
      this.actionEdit = false
      this.stateCustomerId = null
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.setUpVoice()
      this.sheetNote = true
    })
  },
}
</script>

<style scoped lang="scss">
.mdi-menu-down::before {
  margin-top: 0px !important;
  content: '\F035D';
}

/* ==== footer */
/* ======================================== */
.footer {
  align-items: center;
  justify-content: center;
  display: flex;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #eef3fa;
  color: white;
  text-align: center;
  height: 120px;

  &-card {
    width: 100%;
    margin: 15px;
    color: #a50200;
    font-size: 20px;
    // font-weight: bold;
    border-radius: 10px;
    border: 2px dashed #a50200;
    padding: 20px;
  }
}

.footer-submit {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.scard-sm {
  // margin: 0px 40px;
  padding-bottom: 10px;
}

.scard-microphone {
  display: flex;
  justify-content: center;
}

.text-close {
  width: 20%;
  margin-left: 25px;
  text-align: left;
  color: #aeaeae !important;
  display: flex;
  align-items: center;
  justify-items: center;
}

.icon-btn {
  height: 50px !important;
  width: 50px !important;
  margin: 0px 8px;
  border: 1px solid #cfd1d3;
  border-radius: 9px;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 10%);
}

.toobar-v {
  height: 100px !important;
  padding: 20px 0px;

  &.active {
    transform: translateX(0);
    transition: transform 0.4s ease;
  }
}

.icon-size {
  width: 40px;
  height: 40px;
}

.content {
  &-message {
    text-align: left;
    margin: 40px;
  }

  &-tag {
    text-align: left;
    margin: 10px;
  }

  &-chipsiamge {
    position: absolute;
    text-align: left;
    bottom: 8%;
    width: 100%;
  }
}

/* ==== swith */
/* ======================================== */
.switch-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 2px solid #a50200;
  border-radius: 10px;
  overflow: hidden;
  background-color: #eae7e7;
}

.switch-radio {
  position: absolute;
  visibility: hidden;
  display: none;
}

.switch-radio-label {
  // display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  cursor: pointer;
  font-size: 18px !important;
  font-weight: 500;
  padding: 10px 30px;
  margin: 1px;
  background: #ffffff;
  color: #a50200;
  border-radius: 5px;
}

.switch-radio:checked + .switch-radio-label {
  color: #ffffff;
  background: #a50200;
  border: 1px solid;
}

/* ==== button */
/* ======================================== */

.btn-checklist {
  width: 240px !important;
  background-color: #ffffff !important;
  color: #a50200 !important;
  font-size: 25px !important;
  height: 65px !important;
  border-radius: 9px !important;
  border: 1px solid;
}

.btn-submit {
  width: 150px !important;
  background-color: #a50200 !important;
  color: #ffffff !important;
  font-size: 20px !important;
  height: 65px !important;
  border-radius: 9px !important;
}

.btn {
  width: 20%;
  font-size: 22px;
  height: 65px;
  border-radius: 9px;
  margin: 8px;
  border: none;
  box-shadow: none;
  padding: 5px 15px;

  &.tags {
    width: auto;
    color: #ffffff;
    background-color: #ff811c;
  }

  &.person {
    width: auto;
    border: 1px solid !important;
    color: #a50200;
    background-color: #fff1f1;
  }

  &:active {
    outline: none !important;
  }

  &:focus {
    outline: none !important;
  }
}

.img-person {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin: 0px 2px;
}

.t-tag {
  display: flex;
  align-items: center;
  margin: 0;
  padding-right: 10px;
}

.icon-Like-Copy:before {
  color: #a50200 !important;
}

textarea {
  border: none;
  background-color: transparent;
  resize: none;
  outline: none;
}

.icon-microphone {
  left: 48%;
  bottom: 80%;
  z-index: 1000;
  width: 30%;
}

.icon-microphone-bk {
  z-index: 10;
  width: 55%;
  margin-bottom: 30%;
}

// animation
$primary: #a50200;
$size: 150px;
$sizePlay: 140px;

#speech.btn {
  left: 10%;
  border: none;
  padding: 0;
  border-radius: 100%;
  width: $size;
  height: $size;
  font-size: 1.5em;
  color: #fff;
  padding: 0;
  margin: 0;
  background: $primary;
  position: relative;
  display: inline-block;
  line-height: 50px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  margin-bottom: 35%;
}

#speech.active {
  width: $sizePlay;
  height: $sizePlay;
}

.pulse-ring {
  content: '';
  width: $sizePlay;
  height: $sizePlay;
  border: 5px solid $primary;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  left: 0px;
  animation: pulsate infinite 2s;
}

@keyframes pulsate {
  0% {
    -webkit-transform: scale(1, 1);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1.3, 1.3);
    opacity: 0;
  }
}

.icon-notiuser {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 75%;
  border-radius: 50%;
  background: red;
  bottom: 27px;
  left: 30px;
  z-index: 50;
  color: white;
}
</style>
